export default __webpack_public_path__ + "static/media/solucao-01.87f495b8.webp";